export default __webpack_public_path__ + "static/media/chevronUp.bf4bd328.svg";